"use client";

import Link from "next/link";
import Footer from "../components/layouts/footer/Footer";
import Navbar from "../components/layouts/navbar/Navbar";

export default function NotFound() {
  return (
    <>
      <Navbar />
      <div className="flex h-screen flex-col items-center justify-center">
        <div className="mb-60 text-center">
          <p className="mt-10 text-lg/8 font-bold tracking-wide text-GRAY_1 md:text-xl/8">
            エラーが発生しました。
            <br />
            時間をおいて再度お試しください。
          </p>
          <Link
            href="/"
            className="mt-10 inline-block w-fit rounded-full bg-PRIMARY px-5 py-1 font-bold text-WHITE_1 hover:bg-PRIMARY/80 md:text-xl"
          >
            ページトップへ
          </Link>
        </div>
      </div>
      <Footer />
    </>
  );
}
